import db from "@/db";
import LINES from "@/db/enums/lines";

export const getOrderedSamples = async (phaseUuid) => {
  if (!phaseUuid) return [];
  const samples = await db.samples.where("phase").equals(phaseUuid).toArray();

  if (samples.length === 0) {
    return [];
  }

  const ordered = [];
  let current = samples.find((s) => s.previousSample == null);

  if (!current) {
    console.warn(
      "No root sample found for phase",
      phaseUuid,
      "This might be an error in the database."
    );
    return [];
  }

  while (current && ordered.length < samples.length) {
    await current.setRelationships();
    ordered.push(current);
    current = samples.find((s) => s.previousSample === current.uuid);
  }

  if (ordered.length !== samples.length) {
    console.warn(
      "The number of ordered samples does not match the total number of samples for phase",
      phaseUuid
    );
  }

  return ordered;
};

export const getPhaseSignature = async (phaseUuid) => {
  const samples = await getOrderedSamples(phaseUuid);
  return samples.map((x) => x.uuid).join("_");
};

// Parameter-based signature (order-insensitive), comparable across phases
export const getPhaseConfigurationSignature = async (phaseUuid) => {
  if (!phaseUuid) return "";
  const samples = await db.samples.where("phase").equals(phaseUuid).toArray();
  const byText = (a, b) => a.localeCompare(b);
  return samples
    .map(
      (sample) =>
        `${[...sample.mainParameters].sort(byText).join("+")}|${sample.secondParameter ?? ""}`
    )
    .sort(byText)
    .join("_");
};

export const getFirstSample = async (phaseUuid) => {
  const samples = await getOrderedSamples(phaseUuid);
  if (samples.length === 0) return null;
  return samples[0];
};

export const getLastSample = async (phaseUuid) => {
  const samples = await getOrderedSamples(phaseUuid);
  if (samples.length === 0) return null;
  return samples[samples.length - 1];
};

export const isSampleMainLine = async (sample) => {
  const parameter = await db.parameters.get({ uuid: sample.mainParameters[0] });
  if (!parameter) return false;
  return parameter.line === LINES.LIGNE_PRINCIPALE;
};
